<template>
    <div id="SkillViewLayoutLeft">
        <CHeading :variant="2">Popis</CHeading>
        <CCardBox>
            <span class="wysiwyg-enhancement" v-html="skill.content" />
        </CCardBox>
    </div>
</template>

<script setup lang="ts">
import type { Skill } from '#shared/types/Skill'

interface Props {
    skill: Skill
}

defineProps<Props>()
</script>